import React from 'react';
import * as _ from 'lodash';
import axios from 'axios/index';
import {
  Modal,
  FormControl,
  Button,
  ButtonToolbar,
  FormGroup,
  ControlLabel,
  Row,
  Col,
} from 'react-bootstrap';

import FontAwesome from 'react-fontawesome';
import './NewWageItemModal.css';
import {setPartItem} from '../../../../stores/CarDamage/PartItemReducer';

class NewWageItemModal extends React.Component {

  constructor(...args) {
    super(...args);

    this.state = {
      carType: (this.props.carType || '').toUpperCase(),
      partID: this.props.partID,
      additionPartID: '',
      description: '',
      description_en: '',
      part_options: ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      car_type_options: [
        {label: 'รถเก๋ง', value: 'SEDAN'},
        {label: 'รถกระบะ', value: 'PICKUP'},
        {label: 'รถตู้', value: 'VAN'},
        {label: 'รถบรรทุก', value: 'TRUCK'},
      ],
    };
  }

  handleCloseButtonClick = (e) => {
    this.hide();
  };

  handleSaveButtonClick = (e) => {
    this.save();
    this.hide();
  };

  hide(e) {
    const {props, state} = this;

    if (typeof props.onHide === 'function') {
      props.onHide();
    }
  };

  save(e) {
    const {props, state} = this;

    let item = {
      spot_num: props.partID,
      spot_num2: state.additionPartID,
      car_type: props.carType,
      description: state.description,
      description_en: state.description_en,
    };

    const formData = new FormData();
    _.each(item, (value, key) => formData.append(`item[${key}]`, value));

    axios({
      method: 'post',
      url: `/damage/newwageitem`,
      data: formData,
      config: {headers: {'Content-Type': 'multipart/form-data'}},
    }).then((response) => {
      if (typeof props.onSave === 'function') {
        props.onSave(item);
      }
    }).catch((error) => {
      console.log(error);
    });

  };

  render() {
    const {props, state} = this;
    const {show} = props;
    return (
        <Modal show={show} enforceFocus={false}
               onHide={props.onHide}
               dialogClassName="midwidth-dialog new-wage-item-modal-container">
          <Modal.Header closeButton>
            <Modal.Title>{'เพิ่มรายการค่าแรง'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <ControlLabel>ตำแหน่งรถ</ControlLabel>
                  <div className={'part-spot'}>{props.partID}</div>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <ControlLabel>เพิ่มตำแหน่งรถ(ถ้ามี)</ControlLabel>
                  <FormControl
                      value={state.additionPartID}
                      onChange={e => {
                        this.setState({additionPartID: e.target.value});
                      }}
                      componentClass="select">
                    {state.part_options.map((item, index) => (
                        <option key={index} value={item}
                                disabled={item === props.partID}>
                          {item}
                        </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <ControlLabel>ประเภทรถ</ControlLabel>
                  <FormControl
                      disabled={true}
                      value={state.carType}
                      onChange={e => {
                        this.setState({carType: e.target.value});
                      }}
                      componentClass="select">
                    {state.car_type_options.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>ชื่อรายการ(ไทย)</ControlLabel>
                  <FormControl type={'text'}
                               value={state.description}
                               onChange={e => {
                                 this.setState({description: e.target.value});
                               }} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <ControlLabel>ชื่อรายการ(อังกฤษ)</ControlLabel>
                  <FormControl type={'text'}
                               value={state.description_en}
                               onChange={e => {
                                 this.setState(
                                     {description_en: e.target.value});
                               }} />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className={'text-right'}>
              <Button bsStyle={'primary'}
                      onClick={this.handleSaveButtonClick}>
                <FontAwesome name={'save'} /> บันทึก
              </Button>
              <Button bsStyle={'default'}
                      onClick={this.handleCloseButtonClick}>
                <FontAwesome name={'close'} /> ยกเลิก
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
    );
  }
}

export default NewWageItemModal;





// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/NewWageItemModal/NewWageItemModal.js